
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const driverAssignService = {
     getDriverAssignList,
     submitDriverAssign,
     driverAppUserList: DeliverySriverAppUserList,
     driverAppUserDetails: DeliverydriverAppUserDetails,
     submitDeliveryAppUser,
     changeStatusDeliveryAppUser
    
};





async function  getDriverAssignList() {
    return  apiClient.get(`/inventory/driver-assign-list`, authHeader());
}


async function  submitDriverAssign(data) {
    return  apiClient.post(`/inventory/submit-driver-assign`, data, authHeader());
}




async function  submitDeliveryAppUser(data) {
    return  apiClient.post(`/inventory/submit-delivery-app-user`, data, authHeader());
}


async function  changeStatusDeliveryAppUser(data) {
    return  apiClient.post(`/inventory/change-status-delivery-app-user`, data, authHeader());
}


async function  DeliverySriverAppUserList() {
    return  apiClient.get(`/inventory/delivery-driver-app-user-list`, authHeader());
}


async function  DeliverydriverAppUserDetails(id) {
    return  apiClient.get(`/inventory/delivery-driver-app-user-details/${id}`, authHeader());
}










